import { render } from "./StoreProductDetail.vue?vue&type=template&id=3f194768"
import script from "./StoreProductDetail.vue?vue&type=script&lang=js"
export * from "./StoreProductDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__